

import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Getter, Action, Mutation } from "vuex-class"

import vSelect from "vue-select"

// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"
import { BModal } from "bootstrap-vue"

import { CaseDetails } from "@/types"
import { EventMedia } from "@/types/originatingEvents"
import api from "@/services/api"

const caseStore = namespace("cases")

@Component({
	components: {
	}
})
export default class MediaPreview extends Vue {
	$refs!: {
		previewModal: BModal
	}

	@caseStore.State("currentCase")
	public currentCase!: CaseDetails;

	@caseStore.Getter("getPreviewKeyMedia")
	public previewKeyMedia!: EventMedia;

	@caseStore.Mutation
	public setPreviewKeyMedia!: (file: any) => void;

	@Watch("previewKeyMedia")
	onPreviewKeyMediaChanged (newValue: any) {
		if (newValue) {
			this.$refs.previewModal.show()
		} else {
			this.$refs.previewModal.hide()
		}
	}

	private get imagePath (): string {
		if (!this.previewKeyMedia || !this.currentCase) {
			return ""
		}

		return `${api.baseUrl}event/download/${this.currentCase.id}/${this.previewKeyMedia.id}`
	}
}
